import Swiper from 'swiper'

export default function index(){
  const fvslides = document.getElementById('fvslides')
  if(fvslides){
    fvslides.classList.add('active')
  }
}